'use client';

import { getImageProps } from 'next/image';

// The configured Next image loader is a client module. Keep only this image leaf
// on that boundary; it still emits picture/preload markup during server rendering.
export function HeroImage() {
  const { props: heroImage } = getImageProps({
    src: '/images/hero.png',
    alt: 'Vaša lekáreň s ľudským prístupom',
    width: 702,
    height: 988,
    sizes: '500px',
  });

  return (
    <>
      <link
        rel="preload"
        as="image"
        media="(min-width: 1024px)"
        imageSrcSet={heroImage.srcSet}
        imageSizes={heroImage.sizes}
      />
      <picture className="contents">
        <source media="(min-width: 1024px)" srcSet={heroImage.srcSet} sizes={heroImage.sizes} />
        <img
          src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
          alt={heroImage.alt}
          width={702}
          height={988}
          fetchPriority="high"
          decoding="async"
          className="absolute bottom-0 right-[190px] z-[1] hidden h-[400px] w-auto lg:right-[180px] lg:block lg:h-full xl:right-[230px]"
        />
      </picture>
    </>
  );
}
